import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgLinked({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.688 11.312a.974.974 0 011.378-1.378 4.869 4.869 0 010 6.886l-2.755 2.754a4.869 4.869 0 11-6.885-6.885l1.377-1.377a.974.974 0 111.377 1.377l-1.377 1.377a2.921 2.921 0 104.131 4.13l2.755-2.753a2.921 2.921 0 000-4.131zm-1.377 1.377a.974.974 0 01-1.377 1.377 4.869 4.869 0 010-6.886l2.755-2.754a4.869 4.869 0 116.885 6.886l-1.377 1.377a.974.974 0 11-1.377-1.377l1.377-1.378a2.921 2.921 0 00-4.131-4.13L11.31 8.556a2.921 2.921 0 000 4.131z"
        fill={color}
      />
    </svg>
  )
}

export default SvgLinked
